var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444 147L444 175",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 444.5,
    cy: 142.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M439.987 142.19C439.987 138.283 443.288 135.117 447.358 135.117C447.943 135.117 448.511 135.184 449.056 135.308C447.742 134.48 446.187 134 444.519 134C439.814 134 436 137.806 436 142.5C436 147.194 439.814 151 444.519 151C446.814 151 448.895 150.093 450.427 148.62C449.492 149.032 448.454 149.263 447.358 149.263C443.288 149.263 439.987 146.096 439.987 142.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M453.402 141.6L453.37 139.146L451.535 140.719L449.304 140.056L450.112 142.337L448.765 144.381L451.1 144.218L452.499 146.144L453.133 143.763L455.345 142.909L453.402 141.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch5);
export default __webpack_public_path__ + "static/media/church_5.7b813e5a6822911f8ec799fa3087301c.svg";
export { ForwardRef as ReactComponent };